<div class="radio-group d-flex flex-row">
  <label
    *ngFor="let filter of possibleDateFilters"
    class="me-3"
  >
    <input
      type="radio"
      class="form-check-input"
      name="dateOptions"
      [value]="filter"
      [(ngModel)]="selectedDateFilter"
      (change)="onSelectedDateFilterChange()"
    />
    {{ filter }}
  </label>
</div>

<div class="radio-group d-flex flex-list">
  <label
    *ngFor="let filter of possibleErrorFilters"
    class="me-3"
  >
    <input
      type="radio"
      class="form-check-input"
      name="errorOptions"
      [value]="filter"
      [(ngModel)]="selectedErrorFilter"
      (change)="onSelectedErrorFilterChange()"
    />
    {{ filter }}
  </label>
</div>

<input
  type="checkbox"
  class="form-check-input me-2"
  id="processedSalesordersCheckbox"
  [(ngModel)]="filterHideProcessedSalesordersChange"
  (change)="onHideProcessedSalesordersChange()"
/>
<label
  for="processedSalesordersCheckbox"
  class="form-check-label"
>
  Verberg verwerkte verkooporders
</label>
